<!--
  Copyright (c) 2026 Wind River Systems, Inc.

  The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
  -->

<div *ngIf="isImpersonating" class="w-100 impersonation-banner d-flex justify-content-center">
  <span class="font-mono p-2">
    You are impersonating <span class="font-weight-bold">{{ impersonatedUser }}</span>
  </span>
</div>
